module.exports = new __parcel__URL__("shop_resource_packs_button.b1d81b29.png").toString();